<template>
  <div>
    <v-container fluid fill-height>
      <v-card-text class="text-xs-center text-md-center text-lg-center">
        <div class="headline customPrimary--text font-weight-bold">
          <span v-if="loading">{{
            $t("film.upload_link.loader.message")
          }}</span>
          <span v-else-if="error_message">{{
           error_message
          }}</span>
        </div>
        <template v-if="upload_link">
          <div class="text-xs-center">
            <h2 class="primary--text test2">{{ $t('upload_link.welcome_msg') }}</h2>
            <br /><br />
            <div>{{  upload_link.film.title[currentLanguage] }}</div>
            <br /><br />
            <v-img height="200" contain :src="upload_link.film.thumburls"></v-img>
            <br /><br />
            <v-btn color="secondary" dark @click="uploadDropzone" class="mx-0">
              <v-icon small>$vuetify.icons.rms_upload</v-icon>
              {{$t('assets_manager.button.upload')}}
            </v-btn>
            <br /><br />
            <span>{{ $t('upload_link.or') }}</span>
            <br /><br />
            <v-btn color="primary" dark @click="uploadGDrive">
              <v-icon small>$vuetify.icons.rms_upload</v-icon>
              {{$t('assets_manager.button.gd_upload')}}
            </v-btn>
          </div>
          <v-divider class="mt-4"></v-divider>
          <h3 class="mt-4">{{ $t('upload_link.expires') }}: {{ moment.utc(upload_link.created_at).add(28, 'days').local().format('lll') }}</h3>
          <div><small><u>{{ $t('upload_link.expiry_link_inst') }}</u></small></div>
          <v-divider class="mt-4"></v-divider>
          <h3 class="mt-4 mb-2 secondary--text">{{ $t('upload_link.upload_instruction.title') }}</h3>
           <ul class="text-xs-left">
            <li>{{$t("upload_link.upload_instruction.inst_1", {
              'filmTitle' : upload_link.film.title
              }) }}</li>
            <li>{{ $t("upload_link.upload_instruction.inst_2") }}</li>
            <li class="primary--text"><b>{{ $t("upload_link.upload_instruction.inst_3") }}</b></li>
            <li>{{ $t("upload_link.upload_instruction.inst_4") }}</li>
            <li>{{ $t("upload_link.upload_instruction.inst_5") }}</li>
            <li>{{ $t('upload_link.upload_instruction.inst_6') }} 
              <a href="mailto:support@netfest.org">support@netfest.org</a>.
            </li>
          </ul>

        <Uploader
          v-if="show_uploader"
          :show="show_uploader"
          :model="upload_link.film"
          :model_type="upload_conf.model_type"
          :mime_type="upload_conf.mime_type"
          :collection="upload_conf.collection"
          :upload_type="upload_conf.type"
          @close="show_uploader = false"
        ></Uploader>
        </template>
      </v-card-text>
    </v-container>
      <v-footer fixed>
        <v-spacer></v-spacer>
        <div>
            &copy;{{moment()
            .format('YYYY')
            }} —
            <a
              href="https://netfest.org"
              target="_blank"
            >
              <strong class="primary--text" v-html="$t('rms.footer.powered_by')"></strong>
            </a>
        </div>
        <v-spacer></v-spacer>
        <v-btn @click="leave" color="primary">Leave this Page</v-btn>
      </v-footer>
  </div>
</template>

<script>
import Uploader from "@/components/media/Uploader";
import { mapGetters, mapState } from 'vuex';
export default {
  name: "UploadLinkLogin",
  data() {
    return {
      loading: false,
      error_message: null,
      show_uploader: true,
      show_uploader: false,
      upload_type: null,
      upload_conf: {
        collection: 'private',
        model_type: this.DEFINES.MODEL_FILM,
        mime_type: null,
        type: null
      }
    };
  },

  computed: {
    ...mapGetters('auth', {
      isUploadModeLogin : 'isUploadModeLogin',
    }),

    ...mapState({
      upload_link : state => state.auth.upload_link
    }),
    currentLanguage() {
      const userLang = navigator.language || navigator.userLanguage;
      console.log(userLang); // e.g., "en-US", "fr", "ar"
      return userLang.split('-')[0]; // e.g., "en", "fr", "ar"
    },
  },

  components:{
    Uploader
  },

  created(){
    this.loginWithUploadLink();
  },

  methods: {
    async loginWithUploadLink() {
      try{
        if(this.$route.params.link_id == undefined){
          return;
        }
       this.loading = true;
       await  this.$store
        .dispatch("auth/loginWithUploadLink", {
          link_id: this.$route.params.link_id
        });
      }catch(error){
        this.error_message = error.message;
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }finally{
        this.loading = false;
      }
    },

    uploadDropzone(){
      this.upload_conf.type = "dropzone";
      this.show_uploader = true;
    },

    uploadGDrive(){
      this.upload_conf.type = "gdriveUpload";
      this.show_uploader = true;
    },

    leave(){
      this.$store.dispatch ('resetAll');
      this.$router.push({
        name: 'Login'
      });
    }
  }
};
</script>
